module.exports = __webpack_public_path__ + "img/table-columns.6cd2552a.svg";